export default {
    state: {
        filter: {
            period: {
                id: 4,
                value: "4 недели",
            },
            tag: {
                id: 0,
                value: "All"
            },
            userGroup: {
                id: 12,
                value: "Public"
            },
            vendor: {
                id: 0,
                value: "All"
            }
        }
    },
    mutations: {
        setFilter(state, payload) {
            state.filter[payload.name] = {
                id: payload.id,
                value: payload.value
            };
        }
    },
    getters: {
        getFilter(state) {
            return state.filter;
        }
    }
}